<template>
    <div>
        <portal to="modals" v-if="show">
            <div class="modal fade in" :class="classes" role="dialog" style="display:block" @click="close">
                <div class="modal-dialog" @click.stop>
                    <!-- Old event handler: v-click-outside="close" -->
                    <!-- Modal content-->
                    <div class="modal-content modal-border size">
                        <div class="modal-header">
                            <button type="button" class="close" @click="close" data-dismiss="modal">&times;</button>
                            <h4 class="modal-title">{{ title }}</h4>
                        </div>
                        <div class="modal-body">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-backdrop fade in" style="display:block"></div>
        </portal>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                default: ''
            },
            show: {
                default: false
            },
            classes: {
                type: String,
                default: null,
            }
        },
        methods: {
            close() {
                this.$emit('close');
            }
        },
        watch: {
            show(show) {
                if (show) {
                    document.body.style.setProperty('overflow', 'hidden');
                } else {
                    document.body.style.removeProperty('overflow');
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/ModalDialog.vue